import React, { useContext, useEffect, useState } from 'react';
import { Components } from '../../styled';
import ProjectTableHeader from '../../../../components/ProjectTableHeader';
import useFormTextState from '../../../../hooks/useFormTextState';
import ProjectTable from '../../../../components/ProjectTable';
import { filteringModel, tableColumns } from '../../../../components/ProjectTable/constants';
import { ActivityIndicatorContext } from '../../../../providers/ActivityIndicatorProvider/context';
import useModalState from '../../../../hooks/useModalState';
import { AppSettingsContext } from '../../../../providers/AppSettingsProvider/context';
import ProjectSearchDropdown from '../../../../components/ProjectSearchDropdown';
import { Goal, Promotion } from '../../../../api/types/contentManagement';
import { getAllGoals, getAllPromotions } from '../../../../api/contentManagement';
import CreateOrEditGoalModal from '../../../../components/modals/CreateOrEditGoalModal';
import useCustomizedDropdown from '../../../../hooks/useCustomizedDropdown';
import ProjectPicker from '../../../../components/ProjectPicker';
import CreateOrEditPromotionModal from '../../../../components/modals/CreateOrEditPromotionModal';

const Promotions = () => {
  const { setIsLoading } = useContext(ActivityIndicatorContext);

  const [data, setData] = useState<Promotion[]>([]);

  const searchProps = useFormTextState();

  const createPromotionModalProps = useModalState<{ promotion?: Promotion }>();

  const refreshData = async () => {
    setIsLoading(true);
    const result = await getAllPromotions();
    setIsLoading(false);
    if (result && Array.isArray(result)) {
      setData(result);
    }
  };

  useEffect(() => {
    refreshData?.().then();
  }, []);

  const onAddPromotions = () => {
    createPromotionModalProps.open({ promotion: undefined });
  };
  const onEditPromotions = (id: string) => {
    const foundPromotion = data?.find((item) => item?.id === id);
    if (foundPromotion) {
      createPromotionModalProps.open({ promotion: foundPromotion });
    }
  };

  const onCreateOrEditModalClose = (refreshTrigger?: boolean) => {
    if (refreshTrigger) {
      refreshData?.().then();
    }
    createPromotionModalProps.onModalClose();
  };

  const _filteringModel = filteringModel([
    { columnField: 'searchValue', value: searchProps.value, operatorValue: 'contains' },
  ]);
  return (
    <Components.ComponentContainer>
      <ProjectTableHeader
        onSearchChange={searchProps.onChangeText}
        searchLabel={'Search by promotion name or ID'}
        searchPlaceholder={'Enter search term'}>
        <Components.SearchBarSeparator />
        <Components.SearchBarSeparator />
        <Components.PrimaryButton onClick={onAddPromotions}>Add Promotion</Components.PrimaryButton>
      </ProjectTableHeader>
      <Components.TableWrapper>
        <ProjectTable
          data={data || []}
          columns={tableColumns.promotions({ onEdit: onEditPromotions })}
          filteringModel={_filteringModel}
          showRowCountText={'Found promotions'}
          customPageSize={15}
          sortingModel={{ field: 'title', sort: 'asc' }}
        />
      </Components.TableWrapper>
      <CreateOrEditPromotionModal {...createPromotionModalProps} onModalClose={onCreateOrEditModalClose} />
      <Components.SearchBarSeparator />
    </Components.ComponentContainer>
  );
};

export default Promotions;
